<template>
  <div id="header" class="gl-header">
    <div class="row p-3">
      <div class="col col-6" id="lablogo">
        <a href="http://godziklab.org"
          ><img src="images/lab_logo.png" alt="Godzik Lab" height="60px"
        /></a>
        <br /><span id="slogan">Bioinformatics and System Biology</span>
      </div>
      <div id="ucrlogos" class="col col-6 small">
        <a
          href="https://medschool.ucr.edu/"
          target="_blank"
          title="University of California, Riverside School of Medicine"
          class="side-margin float-end"
        >
          <img src="images/ucr3.png" alt="UCR logo" height="35px" />
        </a>
      </div>
    </div>
    <nav id="nav" class="nav bg-primary p-0 pl-4 sticky-top">
      <router-link to="/" class="nav-link text-white">Home</router-link>
      <router-link to="/people" class="nav-link text-white">People</router-link>
      <router-link to="/publications" class="nav-link text-white"
        >Publications</router-link
      >
      <router-link to="/servers" class="nav-link text-white"
        >Servers</router-link
      >
      <router-link to="/contact" class="nav-link text-white"
        >Contact us</router-link
      >
    </nav>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#slogan {
  font-size: 14px;
  color: gray;
  font-style: italic;
}
</style>